import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import Icon from "@/components/icon/Icon.vue";
import WDialog from "@/components/wrappers/w-dialog.vue";
import ExportCsv from "@/views/exportCsv/ExportCsv.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import ImageUploader from "@/components/imageUploader/ImageUploader.vue";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import quizUtils from "@/util/quizUtils";
import WHtmlToolTip from "@/components/tooltip/w-html-tooltip.vue";
let QuestionAnswerImageUploader = class QuestionAnswerImageUploader extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "image", void 0);
    _defineProperty(this, "uploadApiUrl", '/api/v2/images/temp-b64image');
    _defineProperty(this, "displayImageUploader", false);
    _defineProperty(this, "displayItemImageDeletionDialog", false);
  }
  getImagePath(answerImage, prefereSmallVersion) {
    return quizUtils.getAnswerImagePath(answerImage, prefereSmallVersion);
  }
  onImageUploaded($event) {
    return $event;
  }
  onImageDeleteClick() {
    this.displayItemImageDeletionDialog = true;
  }
  onItemImageDeleteConfirm() {
    return this.image;
  }
  onItemImageDeleteCancel() {
    this.displayItemImageDeletionDialog = false;
  }
};
__decorate([Prop({
  default: null
})], QuestionAnswerImageUploader.prototype, "image", void 0);
__decorate([Emit("imageUploaded")], QuestionAnswerImageUploader.prototype, "onImageUploaded", null);
__decorate([Emit("imageDelete")], QuestionAnswerImageUploader.prototype, "onItemImageDeleteConfirm", null);
QuestionAnswerImageUploader = __decorate([Component({
  components: {
    WHtmlToolTip,
    ConfirmDialog,
    ImageUploader,
    StandardButton,
    ExportCsv,
    WDialog,
    WInput,
    Icon
  }
})], QuestionAnswerImageUploader);
export default QuestionAnswerImageUploader;